/**
 * Middleware for handling cleaning up rewards info from session storage.
 */
import { SESSIONSTORAGE_KEY_REWARDS_INFO } from 'constants/rewardsInfo';
import { REDIRECT } from 'constants/reduxActions';
import { removeFromSessionStorage } from 'helpers/ClientUtils';
import marketplace from 'cfg/marketplace.json';
const { authUrl } = marketplace;

export default () => next => action => {
  const { location, type, removeFromSessionStorageFn = removeFromSessionStorage } = action;
  if ((type === REDIRECT) && (location.indexOf(authUrl) > -1)) {
    removeFromSessionStorageFn(SESSIONSTORAGE_KEY_REWARDS_INFO);
  }

  return next(action);
};
